export class LibraryConfig {

    public languages: object;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/interfaces/library-config.interface.ts